function getFaviconElement () {
  return document.querySelector('link[rel="icon"][href*="favicon"]')
}

const update = () => {
  const favicon = getFaviconElement()

  if (favicon) {
    if (document.location.host.includes('rxpai.com')) {
      favicon.href = '/favicon/rxp-favicon.ico'
    } else {
      favicon.href = '/favicon/favicon.ico'
    }
  } else {
    console.warn('Favicon element not found.')
  }
}

export default {
  update
}
